(function () {
  var modal = document.getElementById('pcard-variant-modal');
  if (!modal) return;

  var dom = {
    image: modal.querySelector('[data-pcard-modal-image]'),
    title: modal.querySelector('[data-pcard-modal-title]'),
    price: modal.querySelector('[data-pcard-modal-price]'),
    options: modal.querySelector('[data-pcard-modal-options]'),
    error: modal.querySelector('[data-pcard-modal-error]'),
    submit: modal.querySelector('[data-pcard-modal-submit]'),
    submitText: modal.querySelector('[data-pcard-modal-submit-text]'),
    form: modal.querySelector('[data-pcard-modal-form]'),
    variantInput: modal.querySelector('[data-pcard-modal-variant-input]')
  };

  var state = {
    variants: [],
    optionsMeta: [],
    lockedPosition: null,
    selected: {},
    currentVariant: null,
    trigger: null
  };

  function money(cents) {
    try {
      if (typeof formatMoney === 'function' && window.MinimogSettings) {
        return formatMoney(cents, window.MinimogSettings.money_format);
      }
    } catch (e) {}
    return '\u20B9' + (cents / 100).toFixed(2);
  }

  function openModal() {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('prevent-scroll');
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('prevent-scroll');
    dom.error.hidden = true;
    if (state.trigger) state.trigger.classList.remove('is-loading');
  }

  modal.querySelectorAll('[data-pcard-modal-close]').forEach(function (el) {
    el.addEventListener('click', closeModal);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });

  function findVariant() {
    var positions = state.optionsMeta.map(function (o) { return o.position; });
    return state.variants.find(function (v) {
      return positions.every(function (pos) {
        var val = state.selected[pos];
        return val == null || v['option' + pos] === val;
      });
    }) || null;
  }

  function isValueAvailable(position, value) {
    var testSelected = Object.assign({}, state.selected);
    testSelected[position] = value;
    var positions = state.optionsMeta.map(function (o) { return o.position; });
    var match = state.variants.find(function (v) {
      return positions.every(function (pos) {
        var val = testSelected[pos];
        return val == null || v['option' + pos] === val;
      });
    });
    return !!(match && match.available);
  }

  function renderOptions() {
    dom.options.innerHTML = '';
    state.optionsMeta.forEach(function (opt) {
      if (opt.position === state.lockedPosition) return;

      var wrap = document.createElement('div');
      wrap.className = 'm-pcard-variant-modal__option';

      var label = document.createElement('div');
      label.className = 'm-pcard-variant-modal__option-label';
      label.textContent = opt.name;
      wrap.appendChild(label);

      var valuesWrap = document.createElement('div');
      valuesWrap.className = 'm-pcard-variant-modal__option-values';

      opt.values.forEach(function (val) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'm-pcard-variant-modal__option-value';
        btn.textContent = val;
        if (state.selected[opt.position] === val) btn.classList.add('is-selected');
        if (!isValueAvailable(opt.position, val)) btn.classList.add('is-unavailable');
        btn.addEventListener('click', function () {
          state.selected[opt.position] = val;
          renderOptions();
          updateFromSelection();
        });
        valuesWrap.appendChild(btn);
      });

      wrap.appendChild(valuesWrap);
      dom.options.appendChild(wrap);
    });
  }

  function updateFromSelection() {
    var variant = findVariant();
    state.currentVariant = variant;

    if (variant) {
      dom.price.textContent = money(variant.price);
      dom.variantInput.value = variant.id;
      dom.submit.disabled = !variant.available;
      dom.submitText.textContent = variant.available
        ? ((window.MinimogStrings && window.MinimogStrings.addToCart) || 'Add to Cart')
        : ((window.MinimogStrings && window.MinimogStrings.soldOut) || 'Sold Out');
      dom.error.hidden = true;
      if (variant.featured_image && variant.featured_image.src) {
        dom.image.src = variant.featured_image.src + '&width=600';
      }
    } else {
      dom.submit.disabled = true;
      dom.error.textContent = 'Please select all options';
      dom.error.hidden = false;
    }
  }

  function submitForm() {
    if (dom.form.requestSubmit) {
      dom.form.requestSubmit();
    } else {
      dom.form.submit();
    }
  }

  function addVariantDirectly(variantId, trigger) {
    dom.variantInput.value = variantId;
    if (trigger) trigger.classList.add('is-loading');
    submitForm();
    setTimeout(function () {
      if (trigger) trigger.classList.remove('is-loading');
    }, 1200);
  }

  function openForProduct(trigger) {
    var card = trigger.closest('.m-product-card');
    if (!card) return;

    var dataScript = card.querySelector('[data-pcard-modal-json]');
    if (!dataScript) return;

    var payload;
    try {
      payload = JSON.parse(dataScript.textContent);
    } catch (e) {
      console.error('pcard variant modal: bad json', e);
      return;
    }

    var variants = payload.variants || [];
    var options = payload.options || [];

    var pickerContainer = card.querySelector('[data-pcard-variant-picker]');
    var swatchMatched = pickerContainer && pickerContainer.dataset.swatchMatched === 'true';
    var swatchOptionName = pickerContainer && pickerContainer.dataset.swatchOptionName;

    var cardVariantInput = card.querySelector('[name="id"]');
    var baseVariantId = cardVariantInput ? Number(cardVariantInput.value) : null;
    var baseVariant = variants.find(function (v) { return v.id === baseVariantId; }) || variants[0];

    var optionsMeta = options.map(function (opt) {
      return { name: opt.name, position: opt.position, values: opt.values };
    });

    var lockedPosition = null;
    if (swatchMatched && swatchOptionName) {
      var matched = optionsMeta.find(function (o) {
        return o.name.toLowerCase() === swatchOptionName.toLowerCase();
      });
      if (matched) lockedPosition = matched.position;
    }

    var remaining = optionsMeta.filter(function (o) { return o.position !== lockedPosition; });

    if (remaining.length === 0) {
      addVariantDirectly(baseVariant.id, trigger);
      return;
    }

    state.variants = variants;
    state.optionsMeta = optionsMeta;
    state.lockedPosition = lockedPosition;
    state.selected = {};
    state.trigger = trigger;
    optionsMeta.forEach(function (o) {
      state.selected[o.position] = baseVariant ? baseVariant['option' + o.position] : null;
    });

    var titleNode = card.querySelector('.m-product-card__name');
    dom.title.textContent = titleNode ? titleNode.textContent.trim() : '';

    var cardImg = card.querySelector('.m-product-card__main-image img');
    if (cardImg) dom.image.src = cardImg.currentSrc || cardImg.src;

    renderOptions();
    updateFromSelection();
    openModal();
  }

  dom.submit.addEventListener('click', function () {
    if (dom.submit.disabled) return;
    submitForm();
    closeModal();
  });

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-pcard-add-to-cart-trigger]');
    if (trigger) {
      e.preventDefault();
      openForProduct(trigger);
    }
  });
})();
